/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusFunktionHauptverantwortlichOptionDto } from '../../models/lexplus-funktion-hauptverantwortlich-option-dto';

export interface FunktionenControllerGetHauptverantwortlicheOptionsV1$Params {
  funktionIds?: Array<number>;
}

export function funktionenControllerGetHauptverantwortlicheOptionsV1(http: HttpClient, rootUrl: string, params?: FunktionenControllerGetHauptverantwortlicheOptionsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusFunktionHauptverantwortlichOptionDto>>> {
  const rb = new RequestBuilder(rootUrl, funktionenControllerGetHauptverantwortlicheOptionsV1.PATH, 'get');
  if (params) {
    rb.query('funktionIds', params.funktionIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusFunktionHauptverantwortlichOptionDto>>;
    })
  );
}

funktionenControllerGetHauptverantwortlicheOptionsV1.PATH = '/v1/funktionen/hauptverantwortliche-optionen';
